import { LAYOUT_LIST, TEXT, PDF } from '../items';
import { Translator } from '../Translator';
import { translate } from './translate';

export const InteractivePDF: Translator = sequence => {
  const header: { title: string; subtitle: string; icon: string; id: string } =
    {
      title: '',
      subtitle: '',
      icon: '',
      id: ''
    };

  if (sequence && sequence.items) {
    sequence.items.forEach(item => {
      if (item.__typename === 'Text') {
        header.title = item.title || '';
        header.subtitle = item.subtitle || '';
        header.icon = item.icon || '';
        header.id = item.id || '';
      }
    });
  }

  const root = translate(sequence, item => {
    switch (item.__typename) {
      case 'Card':
        return {
          id: 'layout_list',
          type: LAYOUT_LIST,
          values: {
            align: 'center'
          },
          items: [
            {
              type: TEXT,
              id: `subtitle_${header.id}`,
              items: [],
              values: {
                value: header.subtitle,
                variant: 'sub_heading',
                icon: header?.icon || ''
              }
            },
            {
              type: TEXT,
              id: `title_${header.id}`,
              items: [],
              values: {
                value: header.title,
                variant: 'heading1'
              }
            },
            {
              id: item.id,
              type: PDF,
              values: {
                mediaUrl:
                  item && item.documents && item.documents.length
                    ? item?.documents[0]?.mediaUrl
                    : ''
              },
              items: []
            }
          ]
        };
      default:
        return null;
    }
  });

  return root;
};
